import { gql } from 'apollo-boost';

export const SHIFT_EVENT_CREATE = gql`
  mutation ShiftEventCreate(
    $businessId: ID!
    $startTime: DateTime!
    $endTime: DateTime!
    $slots: Int!
    $title: String!
    $description: String!
    $notifyIds: [ID!]!
    $preapprovedIds: [ID!]!
    $autoCheckoutInterval: Int
    $hardcapped: Boolean!
    $imageInput: ImageInputNullableObject
  ) {
    shift_event_create(
      input: {
        notifications: $notifyIds
        eventParams: {
          businessId: $businessId
          startTime: $startTime
          endTime: $endTime
          preapprovedGroupIds: $preapprovedIds
          slots: $slots
          title: $title
          description: $description
          autoCheckoutInterval: $autoCheckoutInterval
          hardcapped: $hardcapped
          imageInput: $imageInput
        }
      }
    ) {
      event {
        id
        start_time
        end_time
        title
        description
        slots
        business {
          id
        }
        preapproved_group_ids
        auto_checkout_interval
      }
    }
  }
`;
